/**
 * Video Testimonials - CORREGIDO
 * Fixes aplicados: cache limpio, slides válidos, theme editor
 */

(function() {
  'use strict';

  const scriptTag = document.querySelector('script[data-section-id][src*="video-testimonials"]');
  const sectionId = scriptTag?.dataset.sectionId;
  
  if (!sectionId) return;

  const swiperElement = document.querySelector('.swiper-' + sectionId);
  if (!swiperElement) return;

  // ✅ FIX: Permitir reinicialización en Theme Editor
  const isThemeEditor = window.Shopify && Shopify.designMode;
  if (!isThemeEditor && swiperElement.dataset.initialized === 'true') return;
  
  swiperElement.dataset.initialized = 'true';

  // ========================================
  // CACHE CON LIMPIEZA
  // ========================================
  
  const videoCache = new Map();
  let swiperInstance = null;
  let isLoadingVideos = false;
  
  // ✅ FIX: Limpiar cache al editar
  function clearCache() {
    videoCache.clear();
    console.log('🧹 Cache limpiado');
  }
  
  // ========================================
  // CARGAR UN VIDEO
  // ========================================
  
  function loadSingleVideo(container) {
    return new Promise((resolve, reject) => {
      if (!container || container.dataset.videoLoaded === 'true') {
        resolve();
        return;
      }
      
      const cacheKey = container.dataset.cacheId || Math.random().toString(36);
      container.dataset.cacheId = cacheKey;
      
      if (videoCache.has(cacheKey)) {
        container.dataset.videoLoaded = 'true';
        container.classList.add('video-loaded');
        resolve();
        return;
      }
      
      const videoData = container.querySelector('.video-data');
      if (!videoData) {
        resolve();
        return;
      }

      const type = videoData.dataset.type;
      const poster = container.querySelector('.video-poster');
      const soundBtn = container.querySelector('.video-sound-btn');
      let videoElement;

      try {
        if (type === 'giphy') {
          const giphyType = videoData.dataset.giphyType;
          const giphyUrl = videoData.dataset.giphyUrl;

          if (!giphyUrl) {
            reject('No Giphy URL');
            return;
          }

          if (giphyType === 'video') {
            videoElement = document.createElement('video');
            videoElement.className = 'testimonial-video giphy-video';
            videoElement.loop = true;
            videoElement.muted = true;
            videoElement.playsInline = true;
            videoElement.preload = 'metadata';
            
            const source = document.createElement('source');
            source.src = giphyUrl;
            source.type = 'video/mp4';
            videoElement.appendChild(source);
            
            videoElement.onerror = () => reject('Video load failed');
          } else {
            videoElement = document.createElement('img');
            videoElement.className = 'giphy-content';
            videoElement.src = giphyUrl;
            videoElement.loading = 'lazy';
            videoElement.onerror = () => reject('GIF load failed');
          }
          
        } else if (type === 'shopify') {
          videoElement = document.createElement('video');
          videoElement.className = 'testimonial-video';
          videoElement.loop = true;
          videoElement.muted = true;
          videoElement.playsInline = true;
          videoElement.preload = 'metadata';

          const sources = videoData.querySelectorAll('[data-src]');
          if (sources.length === 0) {
            reject('No video sources');
            return;
          }
          
          sources.forEach(srcData => {
            const source = document.createElement('source');
            source.src = srcData.dataset.src;
            source.type = srcData.dataset.type;
            videoElement.appendChild(source);
          });
          
          videoElement.onerror = () => reject('Video load failed');
        }

        if (videoElement) {
          if (poster) {
            poster.style.opacity = '0';
            setTimeout(() => poster.parentNode && poster.remove(), 300);
          }
          
          container.insertBefore(videoElement, container.firstChild);
          container.dataset.videoLoaded = 'true';
          container.classList.add('video-loaded');
          videoCache.set(cacheKey, true);

          if (videoElement.tagName === 'VIDEO' && soundBtn) {
            soundBtn.classList.remove('hidden');
          }

          if (videoElement.tagName === 'VIDEO') {
            videoElement.load();
            videoElement.play().then(() => resolve()).catch(() => resolve());
          } else {
            resolve();
          }
        } else {
          reject('No video element created');
        }
        
      } catch (error) {
        console.error('❌ Error:', error);
        reject(error);
      }
    });
  }

  // ========================================
  // ✅ FIX: CARGAR SOLO SLIDES VÁLIDOS
  // ========================================
  
  async function loadVisibleVideos(swiper) {
    if (isLoadingVideos) return;
    isLoadingVideos = true;
    
    try {
      const slidesPerView = Math.ceil(swiper.params.slidesPerView);
      const activeIndex = swiper.activeIndex;
      
      // ✅ FIX: Filtrar slides reales
      const validSlides = Array.from(swiper.slides).filter(slide => 
        slide && slide.querySelector('.video-container')
      );
      
      console.log('📹 Videos disponibles:', validSlides.length, '| Mostrando:', slidesPerView);
      
      const loadPromises = [];
      
      for (let i = 0; i < slidesPerView; i++) {
        const slideIndex = activeIndex + i;
        
        // ✅ FIX: Validar índice
        if (slideIndex >= validSlides.length) continue;
        
        const slide = validSlides[slideIndex];
        if (!slide) continue;
        
        const container = slide.querySelector('.video-container');
        if (!container || container.dataset.videoLoaded === 'true') continue;
        
        // ✅ FIX: Sin delay en Theme Editor
        const delay = isThemeEditor ? 0 : i * 200;
        
        const loadPromise = new Promise(resolve => {
          setTimeout(() => {
            loadSingleVideo(container)
              .then(() => resolve())
              .catch(() => resolve());
          }, delay);
        });
        
        loadPromises.push(loadPromise);
      }
      
      await Promise.all(loadPromises);
      
    } finally {
      isLoadingVideos = false;
    }
  }

  // ========================================
  // CONTROLAR REPRODUCCIÓN
  // ========================================
  
  function controlVideoPlayback(swiper) {
    const slidesPerView = Math.ceil(swiper.params.slidesPerView);
    const activeIndex = swiper.activeIndex;
    
    swiperElement.querySelectorAll('video').forEach(video => {
      const slide = video.closest('.swiper-slide');
      if (!slide) return;
      
      const slideIndex = Array.from(swiper.slides).indexOf(slide);
      const isVisible = slideIndex >= activeIndex && slideIndex < activeIndex + slidesPerView;
      
      if (isVisible && video.paused) {
        video.play().catch(() => {});
      } else if (!isVisible && !video.paused) {
        video.pause();
      }
    });
  }

  // ========================================
  // ✅ FIX: EVENT LISTENERS SIN DUPLICAR
  // ========================================
  
  function attachEventListeners() {
    const playButtons = swiperElement.querySelectorAll('.video-play-btn');
    const soundButtons = swiperElement.querySelectorAll('.video-sound-btn');
    
    playButtons.forEach(btn => {
      // ✅ FIX: Clonar para eliminar listeners viejos
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      newBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const container = this.closest('.video-container');
        const video = container.querySelector('video');
        
        if (video) {
          video.paused ? video.play().catch(() => {}) : video.pause();
        } else {
          loadSingleVideo(container).catch(err => {
            console.error('Error cargando video:', err);
          });
        }
      });
    });
    
    soundButtons.forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      newBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        const video = this.closest('.video-container').querySelector('video');
        if (video) {
          video.muted = !video.muted;
          this.classList.toggle('unmuted');
        }
      });
    });
  }

  // ========================================
  // INICIALIZAR SWIPER
  // ========================================
  
  function initSwiper() {
    const config = {
      slidesPerView: parseInt(swiperElement.dataset.slidesMobile || '2'),
      spaceBetween: 12,
      loop: false,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      breakpoints: {
        768: {
          slidesPerView: parseInt(swiperElement.dataset.slidesDesktop || '3'),
          spaceBetween: 28,
        }
      },
      on: {
        init: function() {
          console.log('🚀 Swiper inicializado');
          swiperInstance = this;
          attachEventListeners();
          setTimeout(() => loadVisibleVideos(this), 300);
        },
        slideChange: function() {
          setTimeout(() => loadVisibleVideos(this), 50);
        },
        slideChangeTransitionEnd: function() {
          controlVideoPlayback(this);
        },
        resize: function() {
          setTimeout(() => {
            loadVisibleVideos(this);
            controlVideoPlayback(this);
          }, 200);
        }
      }
    };

    const paginationEl = document.querySelector('.swiper-pagination-' + sectionId);
    if (paginationEl) {
      config.pagination = {
        el: '.swiper-pagination-' + sectionId,
        clickable: true,
      };
    }

    const prevBtn = document.querySelector('.swiper-button-prev-' + sectionId);
    const nextBtn = document.querySelector('.swiper-button-next-' + sectionId);
    if (prevBtn && nextBtn) {
      config.navigation = {
        nextEl: '.swiper-button-next-' + sectionId,
        prevEl: '.swiper-button-prev-' + sectionId,
      };
    }

    if (swiperElement.dataset.autoplay === 'true') {
      config.autoplay = {
        delay: parseInt(swiperElement.dataset.autoplayDelay || '5000'),
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    // ✅ FIX: Destruir swiper anterior si existe
    if (swiperInstance) {
      swiperInstance.destroy(true, true);
    }
    
    const swiper = new Swiper('.swiper-' + sectionId, config);
    swiperInstance = swiper;

    // Intersection Observer
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          swiperElement.querySelectorAll('video').forEach(video => {
            if (!video.paused) video.pause();
          });
        } else if (swiperInstance) {
          controlVideoPlayback(swiperInstance);
        }
      });
    }, { threshold: 0.1 });

    const section = swiperElement.closest('.video-testimonials-section');
    if (section) sectionObserver.observe(section);
  }

  // ========================================
  // CARGAR SWIPER LIBRARY
  // ========================================
  
  function loadSwiperLibrary() {
    if (window.Swiper) {
      initSwiper();
      return;
    }

    if (window.swiperLoading) {
      window.addEventListener('swiperReady', initSwiper, { once: true });
      return;
    }

    window.swiperLoading = true;

    const cssLink = document.createElement('link');
    cssLink.rel = 'stylesheet';
    cssLink.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(cssLink);

    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    script.async = true;
    script.onload = () => {
      window.swiperLoading = false;
      window.dispatchEvent(new Event('swiperReady'));
      initSwiper();
    };
    script.onerror = () => {
      console.error('❌ Error cargando Swiper');
      window.swiperLoading = false;
    };
    document.head.appendChild(script);
  }

  // ========================================
  // ✅ FIX: THEME EDITOR SUPPORT
  // ========================================
  
  if (isThemeEditor) {
    // Cargar inmediatamente en editor
    loadSwiperLibrary();
    
    // ✅ FIX: Limpiar al descargar sección
    document.addEventListener('shopify:section:unload', function(event) {
      if (event.detail.sectionId === sectionId) {
        console.log('🗑️ Limpiando sección...');
        clearCache();
        if (swiperInstance) {
          swiperInstance.destroy(true, true);
          swiperInstance = null;
        }
        swiperElement.dataset.initialized = 'false';
      }
    });
    
    // ✅ FIX: Reiniciar al cargar sección (sin reload)
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === sectionId) {
        console.log('🔄 Recargando sección...');
        clearCache();
        swiperElement.dataset.initialized = 'false';
        setTimeout(() => {
          if (window.Swiper) {
            initSwiper();
          } else {
            loadSwiperLibrary();
          }
        }, 100);
      }
    });
    
  } else {
    // Lazy load en frontend
    const lazyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadSwiperLibrary();
          lazyObserver.disconnect();
        }
      });
    }, { rootMargin: '200px' });

    lazyObserver.observe(swiperElement);
  }

})();
